
import './App.css';
import StreetSweepingApp from './streetsweepingapp/StreetSweepingApp';

function App() {
  return (
    <div className="App">
      <StreetSweepingApp></StreetSweepingApp>
    </div>
  );
}

export default App;
